/**
 * Mobile-responsive layout for the schedule settings row (date / time /
 * recurrence / delivery).
 *
 * Desktop keeps the roomy single-row `160px 160px 1fr 1fr` grid. On mobile the
 * forced `repeat(4, minmax(0,1fr))` crammed every control to ~78-85px (unusable
 * MUI date/time fields); instead we lay date + time out 2-up on the first row
 * and let recurrence + delivery each span the full width beneath. This is a pure
 * function of the mobile flag so it can be unit-tested without a DOM — the
 * component just spreads the result into its `sx`.
 */
export interface ScheduleGridSx {
  display: 'grid';
  gridTemplateColumns: string;
  /** present only on mobile: makes the 3rd/4th items (recurrence, delivery) full-width */
  ['& > *:nth-of-type(n+3)']?: { gridColumn: string };
}

export function scheduleSettingsGridSx(isMobile: boolean): ScheduleGridSx {
  if (isMobile) {
    return {
      display: 'grid',
      // date + time share the first row; recurrence + delivery stack full-width
      gridTemplateColumns: '1fr 1fr',
      '& > *:nth-of-type(n+3)': { gridColumn: '1 / -1' },
    };
  }
  return {
    display: 'grid',
    gridTemplateColumns: '160px 160px 1fr 1fr',
  };
}
